import { z } from 'zod';
/**
 * اتجاه الحوالة (TRF-40). BANK_TO_CASH (من بنك إلى نقد) is the original flow:
 * the amount arrives in the store's bank account (+amount) and the box pays
 * the net cash (−net). CASH_TO_BANK (من نقد إلى بنك) is its mirror: the box
 * receives the cash (+amount) and the bank account sends the net to the
 * receiver's bank (−net). The commission is the same tier commission,
 * amount − net, in both directions. Transfers created before directions
 * existed are BANK_TO_CASH.
 */
export const TRANSFER_DIRECTIONS = ['BANK_TO_CASH', 'CASH_TO_BANK'];
export const transferDirectionSchema = z.enum(TRANSFER_DIRECTIONS);
export const DEFAULT_TRANSFER_DIRECTION = 'BANK_TO_CASH';
/**
 * The party who is present at the branch, fills the level-A form and signs:
 * the receiver of a BANK_TO_CASH transfer, the sender of a CASH_TO_BANK one.
 * With المرسل هو المستلم the one person is kept in the receiver slot.
 */
export function presentPartyRole(direction, senderIsReceiver) {
    return direction === 'CASH_TO_BANK' && !senderIsReceiver ? 'SENDER' : 'RECEIVER';
}
/**
 * طريقة احتساب العمولة (TRF-60), chosen per CASH_TO_BANK transfer as the
 * customer chooses. The tier is looked up on the entered amount in both modes.
 *
 * - DEDUCTED (تخصم من المبلغ, the default): the customer hands over the
 *   entered amount and the receiver gets amount − commission.
 * - ADDED (تضاف على المبلغ): the receiver gets the entered amount and the
 *   customer hands over amount + commission.
 *
 * A posted transfer always stores `amount` = what comes in (the cash received
 * for CASH_TO_BANK) and `net` = what goes out, so commission = amount − net in
 * both modes. BANK_TO_CASH has no choice and is always DEDUCTED.
 */
export const TRANSFER_COMMISSION_MODES = ['DEDUCTED', 'ADDED'];
export const transferCommissionModeSchema = z.enum(TRANSFER_COMMISSION_MODES);
export const DEFAULT_TRANSFER_COMMISSION_MODE = 'DEDUCTED';
/** The mode that applies: BANK_TO_CASH is always DEDUCTED (TRF-60). */
export function effectiveCommissionMode(direction, mode) {
    return direction === 'CASH_TO_BANK' && mode === 'ADDED' ? 'ADDED' : 'DEDUCTED';
}
//# sourceMappingURL=direction.js.map